export const getTableOfContents = (): void => {
  window.onload = setupTableOfContents
}

const querySelectorMobileOrDesktop = (selector: string, isMobile: boolean): HTMLElement | null => {
  return document.querySelector(`${isMobile ? '.mobile' : '.desktop'} ${selector}`)
}

const createTocEntry = (item: HTMLHeadingElement, tocList: HTMLElement, observer: IntersectionObserver): void => {
  if (!item.id && item.textContent) {
    const textId = item.textContent
      .replace(/\s/g, '-')
      .replace(/\?/g, '')
      .replace(/^[0-9]+|[^A-Za-z0-9-]/g, '')
      .replace(/\./g, '')
      .toLowerCase()

    item.id = textId

    const li = document.createElement('li')
    const link = document.createElement('a')
    link.textContent = item.textContent
    link.href = `#${textId}`

    li.append(link)
    tocList.append(li)
    observer.observe(item)
  }
}

const observeTabSections = (tabElements: {
  tab: HTMLElement | null,
  href: string | null
}[], tabObserver: IntersectionObserver): void => {
  tabElements.forEach(({ href }) => {
    if (href) {
      const id = href.replace('#', '')
      const el = document.getElementById(id)
      if (el) tabObserver.observe(el)
    }
  })

  const theorySection = document.querySelector('.content-box') || document.querySelector('article') || document.body
  if (theorySection) {
    tabObserver.observe(theorySection)
  }
}

const setupTableOfContents = (): void => {
  const isMobile = document.documentElement.clientWidth < 900

  const headers = document.querySelectorAll<HTMLHeadingElement>('.content-box h2, .content-box h3')
  const toc = querySelectorMobileOrDesktop('#toc', isMobile)
  const tocList = querySelectorMobileOrDesktop('#toc #toc-list', isMobile)
  const tocTrigger = querySelectorMobileOrDesktop('#toc-trigger', isMobile)

  const tabTheory = querySelectorMobileOrDesktop('#toc-trigger', isMobile) // Fix typo: "#toc-tirgger"
  const tabPractice = querySelectorMobileOrDesktop('#tab-practice', isMobile)
  const tabWorksheets = querySelectorMobileOrDesktop('#tab-worksheets', isMobile)

  let prevTargetId: string | null = null

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const id = entry.target.id.replace(/^[0-9]+|[^A-Za-z0-9-]/g, '')
      const link = tocList?.querySelector(`a[href="#${id}"]`)
      if (entry.isIntersecting && Math.abs(entry.boundingClientRect.top) <= 100 && prevTargetId !== id) {
        link?.classList.add('active')
        tocList?.querySelector(`a[href="#${prevTargetId}"]`)?.classList.remove('active')
        prevTargetId = id
      }
    })
  }, {
    threshold: [0, 1],
    rootMargin: '-100px 0px 100px 0px'
  })

  const tabObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return

      [tabTheory, tabPractice, tabWorksheets].forEach(tab => tab?.classList.remove('active'))

      const sectionId = entry.target.id
      const initPracticeId = tabPractice?.getAttribute('href')?.replace('#', '')
      const initWorksheetsId = tabWorksheets?.getAttribute('href')?.replace('#', '')

      if (initPracticeId === sectionId) {
        tabPractice?.classList.add('active')
        tabTheory?.classList.remove('open')
        tocList?.classList.remove('active')
      } else if (initWorksheetsId === sectionId) {
        tabWorksheets?.classList.add('active')
        tabTheory?.classList.remove('open')
        tocList?.classList.remove('active')
      } else {
        tabTheory?.classList.add('active')
      }
    })
  }, {
    threshold: 0.2,
    rootMargin: '-100px 0px -50% 0px'
  })

  headers.forEach(item => {
    if (tocList) createTocEntry(item, tocList, observer)
  })

  setTimeout(() => {
    observeTabSections([
      { tab: tabPractice, href: tabPractice?.getAttribute('href') || null },
      { tab: tabWorksheets, href: tabWorksheets?.getAttribute('href') || null }
    ], tabObserver)
  }, 500)

  if (tocList) {
    tocList.addEventListener('click', () => {
      tocList.classList.remove('active')
      toc?.classList.remove('is-open')
      tabTheory?.classList.add('active')
      tabPractice?.classList.remove('active')
      tabWorksheets?.classList.remove('active')
      tocTrigger?.classList.remove('open')
    })
  }
  if (tocTrigger) {
    tocTrigger?.addEventListener('click', () => {
      tocList?.classList.toggle('active')
      tocTrigger.classList.toggle('open')
    })
  }
  if (tabTheory) {
    tabTheory.classList.add('active')
  }
}
